import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { incluye } from '../data/oferta';
export function IncluyeSection() {
  return <section aria-labelledby="incluye-titulo" className="border-b border-violet-line/40 bg-violet" data-id="element-36" data-mp="11338l6goomzz">
      <div className="mx-auto max-w-5xl px-6 py-20 sm:py-24 lg:px-8" data-id="element-37" data-mp="w9s4hd39akbr">
        <h2 id="incluye-titulo" className="font-serif text-3xl font-medium leading-tight text-bone sm:text-4xl" data-id="element-38" data-mp="rc8oa7mzzxh6">
          Qué incluye
        </h2>

        <ul className="mt-12 grid gap-x-12 gap-y-8 sm:grid-cols-2" data-id="element-39" data-mp="ibtxisr9lq6a">
          {incluye.map(item => <li key={item.titulo} className="flex gap-4" data-id="element-40" data-mp="de1x1ack0vqh">
              <span className={'mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full ' + (item.bono ? 'bg-gold text-violet-deep' : 'border border-gold/40 text-gold')} data-id="element-41" data-mp="8dw3tpqmz16a">
                {item.bono ? <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-42" data-mp="31bx8p1lz8l7l" /> : <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-43" data-mp="35fd11lr0jzeh" />}
              </span>
              <div data-id="element-44" data-mp="2rfu6jvr4kmkn">
                <h3 className="font-sans text-base font-medium leading-snug text-bone" data-id="element-45" data-mp="2rgdcee3i3kib">
                  {item.titulo}
                </h3>
                <p className="mt-1.5 font-sans text-sm font-light leading-relaxed text-bone/65" data-id="element-46" data-mp="3k3gc39jwy1a5">
                  {item.detalle}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}